// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Faq_wrapper"};